import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight, X, ThumbsUp, MessageCircle, Share2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const testimonials = [{
  id: 1,
  photo: 'https://cdn.magicpatterns.com/uploads/6w7tBAPN663FnYtMU2DcGC/Raw_candid_UGC-style_202604112138.png',
  text: 'Mis nietas no querían saber nada de rezar. Desde que llegó este pack, ellas mismas me piden que saquemos las láminas. Ahora tenemos nuestro momento sagrado todas las tardes. Gracias de corazón. 🙏',
  name: 'Rosa Morales',
  city: 'Temuco',
  time: 'hace 2 días',
  likes: 147,
  initials: 'RM',
  avatarColor: '#87CEEB'
}, {
  id: 2,
  photo: 'https://cdn.magicpatterns.com/uploads/i1rbcHsVZBkbmXCAJivN8y/Raw_candid_UGC-style_202604112137.png',
  text: 'Lo compramos casi sin esperanza, ya habíamos probado de todo. La primera noche Santi se quedó dormido con las manos juntas. Mi señora y yo nos miramos y no podíamos creerlo. Vale cada peso y mucho más ❤️',
  name: 'Familia Rojas',
  city: 'Santiago',
  time: 'hace 5 días',
  likes: 312,
  initials: 'FR',
  avatarColor: '#9CAF88'
}, {
  id: 3,
  photo: 'https://cdn.magicpatterns.com/uploads/rhnCJ41mq6mrJSDvq3h3ML/Raw_candid_UGC-style_202604112135_(2).png',
  text: 'Soy mamá soltera y siempre me sentí culpable por no saber cómo enseñarle la fe a mi hija. Esto cambió todo. Ahora ella me enseña a mí. Me dice "mamá, hoy le damos gracias por el sol". Me derrite el corazón 😭✨',
  name: 'Camila Vega',
  city: 'Valparaíso',
  time: 'hace 1 semana',
  likes: 289,
  initials: 'CV',
  avatarColor: '#FF6B35'
}, {
  id: 4,
  photo: 'https://cdn.magicpatterns.com/uploads/eXsEV3TvaogX4NxyMLbyTL/Raw_candid_UGC-style_202604112135_(1).png',
  text: 'Soy abuelo y no sabía cómo conectar con mi nieto en esto de la fe. Con las láminas del Arca de Noé se me abrió una puerta. Ahora él me explica los dibujos a mí. Es el mejor momento de mi semana, sin duda 👴❤️',
  name: 'Jorge Araya',
  city: 'Concepción',
  time: 'hace 3 días',
  likes: 201,
  initials: 'JA',
  avatarColor: '#2C3E50'
}, {
  id: 5,
  photo: 'https://cdn.magicpatterns.com/uploads/bytp95chQTehaYGEyJaY1a/Raw_candid_UGC-style_202604112135.png',
  text: 'Pensé que era otro libro religioso aburrido. Me equivoqué completamente. Mi nieto de 5 años me pregunta cada mañana si vamos a colorear y rezar. Nunca imaginé que a esta edad iba a tener estos momentos tan lindos 🌟',
  name: 'Manuel Torres',
  city: 'La Serena',
  time: 'hace 4 días',
  likes: 178,
  initials: 'MT',
  avatarColor: '#87CEEB'
}];
function FacebookCard({
  t,
  onImageClick
}: {
  t: (typeof testimonials)[0];
  onImageClick: () => void;
}) {
  const [liked, setLiked] = useState(false);
  return <div className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100 flex flex-col" data-id="element-141">
      {/* FB Header */}
      <div className="px-4 pt-4 pb-2 flex items-center gap-3" data-id="element-142">
        <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0" style={{
        backgroundColor: t.avatarColor
      }} data-id="element-143">
          {t.initials}
        </div>
        <div className="flex-1 min-w-0" data-id="element-144">
          <p className="font-bold text-charcoal text-sm leading-tight" data-id="element-145">
            {t.name}
          </p>
          <div className="flex items-center gap-1 text-gray-400 text-xs" data-id="element-146">
            <span data-id="element-147">
              {t.time} · {t.city}
            </span>
            <span data-id="element-148">·</span>
            <span data-id="element-149">🌍</span>
          </div>
        </div>
        {/* FB logo */}
        <div className="w-6 h-6 rounded-full bg-[#1877F2] flex items-center justify-center flex-shrink-0" data-id="element-150">
          <span className="text-white font-bold text-xs leading-none" data-id="element-151">f</span>
        </div>
      </div>

      {/* Stars */}
      <div className="px-4 pb-2 flex gap-0.5" data-id="element-152">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" data-id="element-153" />)}
      </div>

      {/* Post text */}
      <div className="px-4 pb-3" data-id="element-154">
        <p className="text-gray-700 text-sm leading-relaxed" data-id="element-155">{t.text}</p>
      </div>

      {/* Photo — clickable */}
      <div className="relative w-full overflow-hidden cursor-pointer group" style={{
      aspectRatio: '4/3'
    }} onClick={onImageClick} data-id="element-156">
        <img src={t.photo} alt={t.name} className="w-full h-full object-cover object-center transition-transform duration-300 group-hover:scale-105" data-id="element-157" />
        {/* Hand pointer hint overlay */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300 flex items-center justify-center" data-id="element-158">
          <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/90 rounded-full px-3 py-1.5 flex items-center gap-1.5 shadow-lg" data-id="element-159">
            <span className="text-lg" data-id="element-160">👆</span>
            <span className="text-xs font-bold text-charcoal" data-id="element-161">Ver foto</span>
          </div>
        </div>
      </div>

      {/* Like count */}
      <div className="px-4 py-2 flex items-center justify-between text-xs text-gray-400 border-b border-gray-100" data-id="element-162">
        <div className="flex items-center gap-1" data-id="element-163">
          <div className="w-4 h-4 rounded-full bg-[#1877F2] flex items-center justify-center" data-id="element-164">
            <ThumbsUp className="w-2.5 h-2.5 text-white fill-white" data-id="element-165" />
          </div>
          <span data-id="element-166">{liked ? t.likes + 1 : t.likes}</span>
        </div>
        <span data-id="element-167">Ver comentarios</span>
      </div>

      {/* Action buttons */}
      <div className="px-2 py-1 grid grid-cols-3 divide-x divide-gray-100" data-id="element-168">
        <button onClick={() => setLiked(!liked)} className={`flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold transition-colors ${liked ? 'text-[#1877F2]' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-169">
          <ThumbsUp className={`w-4 h-4 ${liked ? 'fill-[#1877F2]' : ''}`} data-id="element-170" />
          Me gusta
        </button>
        <button className="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold text-gray-500 hover:bg-gray-50 transition-colors" data-id="element-171">
          <MessageCircle className="w-4 h-4" data-id="element-172" />
          Comentar
        </button>
        <button className="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold text-gray-500 hover:bg-gray-50 transition-colors" data-id="element-173">
          <Share2 className="w-4 h-4" data-id="element-174" />
          Compartir
        </button>
      </div>
    </div>;
}
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="py-20 px-6 bg-cream overflow-hidden" data-id="element-175">
      <div className="max-w-6xl mx-auto" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <h2 className="font-fredoka text-3xl md:text-5xl text-charcoal mb-4" data-id="element-178">
            Lo que dicen las familias que ya lo usan
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-179">
            Más de 1.000 familias ya oran juntas cada noche.
          </p>
        </div>

        {/* Desktop Grid — 3 + 2 */}
        <div className="hidden md:block mb-12" data-id="element-180">
          <div className="grid grid-cols-3 gap-6 mb-6" data-id="element-181">
            {testimonials.slice(0, 3).map((t, i) => <FacebookCard key={t.id} t={t} onImageClick={() => setLightboxIndex(i)} data-id="element-182" />)}
          </div>
          <div className="grid grid-cols-2 gap-6 max-w-2xl mx-auto" data-id="element-183">
            {testimonials.slice(3).map((t, i) => <FacebookCard key={t.id} t={t} onImageClick={() => setLightboxIndex(i + 3)} data-id="element-184" />)}
          </div>
        </div>

        {/* Mobile Carousel */}
        <div className="md:hidden relative mb-12" data-id="element-185">
          <div className="overflow-hidden px-2 py-4" data-id="element-186">
            <AnimatePresence mode="wait" data-id="element-187">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.3
            }} data-id="element-188">
                <FacebookCard t={testimonials[currentIndex]} onImageClick={() => setLightboxIndex(currentIndex)} data-id="element-189" />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="flex justify-center items-center gap-6 mt-4" data-id="element-190">
            <button onClick={prev} className="p-2 rounded-full bg-white shadow-md text-charcoal hover:bg-gray-50" data-id="element-191">
              <ChevronLeft className="w-6 h-6" data-id="element-192" />
            </button>
            <div className="flex gap-2" data-id="element-193">
              {testimonials.map((_, idx) => <div key={idx} className={`w-2.5 h-2.5 rounded-full transition-colors ${idx === currentIndex ? 'bg-sage-green' : 'bg-gray-300'}`} data-id="element-194" />)}
            </div>
            <button onClick={next} className="p-2 rounded-full bg-white shadow-md text-charcoal hover:bg-gray-50" data-id="element-195">
              <ChevronRight className="w-6 h-6" data-id="element-196" />
            </button>
          </div>
        </div>

        <div className="text-center" data-id="element-197">
          <button onClick={() => document.getElementById('precio')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-sage-green text-white hover:bg-[#8ab075] font-bold text-lg py-4 px-8 rounded-2xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300" data-id="element-198">
            QUIERO RESULTADOS COMO ESTOS
          </button>
        </div>
      </div>

      {/* Lightbox Modal */}
      <AnimatePresence data-id="element-199">
        {lightboxIndex !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
        backgroundColor: 'rgba(0,0,0,0.85)'
      }} onClick={() => setLightboxIndex(null)} data-id="element-200">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          duration: 0.25
        }} className="bg-white rounded-3xl overflow-hidden max-w-3xl w-full max-h-[90vh] flex flex-col md:flex-row shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-201">
              {/* Image side */}
              <div className="w-full md:w-1/2 flex-shrink-0" data-id="element-202">
                <img src={testimonials[lightboxIndex].photo} alt={testimonials[lightboxIndex].name} className="w-full h-64 md:h-full object-cover object-center" data-id="element-203" />
              </div>

              {/* Content side */}
              <div className="w-full md:w-1/2 p-6 flex flex-col justify-between overflow-y-auto" data-id="element-204">
                {/* FB-style header */}
                <div data-id="element-205">
                  <div className="flex items-center gap-3 mb-4" data-id="element-206">
                    <div className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0" style={{
                  backgroundColor: testimonials[lightboxIndex].avatarColor
                }} data-id="element-207">
                      {testimonials[lightboxIndex].initials}
                    </div>
                    <div data-id="element-208">
                      <p className="font-bold text-charcoal" data-id="element-209">
                        {testimonials[lightboxIndex].name}
                      </p>
                      <p className="text-gray-400 text-xs" data-id="element-210">
                        {testimonials[lightboxIndex].time} ·{' '}
                        {testimonials[lightboxIndex].city} · 🌍
                      </p>
                    </div>
                    <div className="ml-auto w-7 h-7 rounded-full bg-[#1877F2] flex items-center justify-center" data-id="element-211">
                      <span className="text-white font-bold text-sm" data-id="element-212">f</span>
                    </div>
                  </div>

                  <div className="flex gap-0.5 mb-4" data-id="element-213">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-214" />)}
                  </div>

                  <p className="text-gray-700 leading-relaxed text-base italic" data-id="element-215">
                    "{testimonials[lightboxIndex].text}"
                  </p>
                </div>

                <div className="mt-6 pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-216">
                  <div className="flex items-center gap-1 text-gray-400 text-sm" data-id="element-217">
                    <div className="w-5 h-5 rounded-full bg-[#1877F2] flex items-center justify-center" data-id="element-218">
                      <ThumbsUp className="w-3 h-3 text-white fill-white" data-id="element-219" />
                    </div>
                    <span data-id="element-220">{testimonials[lightboxIndex].likes} personas</span>
                  </div>
                  <button onClick={() => setLightboxIndex(null)} className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-charcoal transition-colors" data-id="element-221">
                    <X className="w-4 h-4" data-id="element-222" />
                    Cerrar
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}